import './scss/index.scss';
import { dcFactory } from 'dc';
import FooterNavComponent from './js/toggle-navigation';

dcFactory.register(FooterNavComponent);
